import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ClientChatTab from '@/pages/client/dashboard/components/ClientChatTab';

/**
 * Bulle flottante « Chat IA » du compte client (/mon-compte).
 * Elle ouvre le VRAI chat IA (recherche, panier, réservations, notes vocales,
 * changement de devise) dans un panneau flottant, sans quitter la page en
 * cours. Masquée sur l'onglet /mon-compte/chat pour éviter le doublon.
 */
export default function ClientAssistantDock() {
  const [open, setOpen] = useState(false);
  // Badge « Nouvelle réponse » : s'affiche quand l'IA répond alors que le
  // panneau est fermé.
  const [unread, setUnread] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onReply = () => {
      setOpen((isOpen) => {
        if (!isOpen) setUnread(true);
        return isOpen;
      });
    };
    window.addEventListener('zifek:assistant-replied', onReply);
    return () => window.removeEventListener('zifek:assistant-replied', onReply);
  }, []);

  const openPanel = () => {
    setUnread(false);
    setOpen(true);
  };

  if (location.pathname.startsWith('/mon-compte/chat')) return null;

  return (
    <>
      {!open && (
        <button
          type="button"
          onClick={openPanel}
          className="fixed bottom-20 lg:bottom-6 right-4 lg:right-6 z-40 w-14 h-14 rounded-full bg-primary-500 text-background-50 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer"
          title={unread ? 'Nouvelle réponse de l’assistant' : 'Ouvrir le chat IA'}
          aria-label={unread ? 'Nouvelle réponse de l’assistant' : 'Ouvrir le chat IA'}
        >
          <i className="ri-robot-2-line text-2xl"></i>
          {unread ? (
            <span className="absolute -top-1.5 -right-1.5 flex items-center gap-1 pl-1 pr-2 h-6 rounded-full bg-accent-500 text-background-50 text-[10px] font-bold border-2 border-background-50 whitespace-nowrap">
              <i className="ri-notification-3-fill text-[11px]"></i>
              Nouvelle réponse
            </span>
          ) : (
            <span className="absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-50"></span>
          )}
        </button>
      )}

      {open && (
        <div className="fixed inset-x-0 bottom-0 sm:inset-auto sm:bottom-6 sm:right-6 z-[55] w-full sm:w-[420px] h-[88dvh] sm:h-[640px] bg-background-50 border border-background-200/70 rounded-t-2xl sm:rounded-2xl flex flex-col overflow-hidden">
          <div className="flex items-center gap-2.5 px-3.5 py-2.5 border-b border-background-200/70 flex-shrink-0">
            <div className="relative flex-shrink-0">
              <div className="w-9 h-9 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-robot-2-line text-base"></i>
              </div>
              <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-accent-500 border-2 border-background-50"></span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold font-heading text-foreground-950 leading-tight truncate">Assistant IA</p>
              <p className="text-[10px] text-foreground-500 truncate">Recherche, panier, réservations</p>
            </div>
            <Link
              to="/mon-compte/chat"
              onClick={() => setOpen(false)}
              className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 hover:bg-background-100 transition-colors cursor-pointer"
              title="Ouvrir en plein écran"
            >
              <i className="ri-expand-diagonal-line text-sm"></i>
            </Link>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 hover:bg-background-100 transition-colors cursor-pointer"
              title="Fermer"
              aria-label="Fermer le chat IA"
            >
              <i className="ri-close-line"></i>
            </button>
          </div>

          <div className="flex-1 min-h-0 p-2">
            <ClientChatTab />
          </div>
        </div>
      )}
    </>
  );
}